import { user } from "./user";
import { common } from "./common";
import { link } from "./link";
import { auth } from "./auth";
import { cr } from "fire-wind-water";
import { Subject, combineLatest } from "rxjs";
import {
  getOpenId,
  getSession,
  getToken,
  getTokenInfo,
  getVerify,
  getVerifyInfo,
  removeCookieId,
  removeOpenId,
  removeSession,
  removeToken,
  removeTokenInfo,
  removeVerify,
  removeVerifyInfo,
  setOpenId,
  setSession,
  setToken,
  setTokenInfo,
  setVerify,
  setVerifyInfo,
} from "./cookie";
import { $module } from "../conf/module";

class Module {
  static modules: { [label: string]: string | any }[] = [];
  static userStatus: any = {};

  static instance: any = {};

  static asyncStatus: { [label: string]: Subject<any> } = {
    userEnd: new Subject(),
    userChange: new Subject(),
    linkInit: new Subject(),
  };

  skModule: any[] = [];
  skQrCodeRender: any = link.qrCodeRender;

  constructor() {
    combineLatest([
      Module.asyncStatus.linkInit,
      Module.asyncStatus.userEnd,
    ]).subscribe(() => {
      link.init(Module.instance).subscribe(() => {
        this.skLinkEnd();
      });
    });
    $module.subscribe((res) => {
      if (res.type === "user-change") {
        this.skUserChange(res.data);
      }
    });
    this.init();
  }

  async init() {
    Module.initSubscribe(this);
    await user.getId();
    common.init();
    this.skUserInit();
  }

  static initSubscribe(t) {
    common.$content.subscribe(() => {
      t.skInit();
      user.getAsyncInfo().then(() => {
        t.skUserEnd();
      });
    });
  }

  module(o: any): { [label: string]: any } {
    const _this = this;
    const key = `sk_temp_module_${new Date().getTime()}`;
    Module.modules.push({
      key,
      model: o,
    });
    if (Module.userStatus.skInit) {
      if (o.skInit) {
        o.skInit();
      }
    }
    if (Module.userStatus.init) {
      if (o.skUserInit) {
        o.skUserInit();
      }
    }
    if (Module.userStatus.end) {
      if (o.skUserEnd) {
        o.skUserEnd();
      }
    }
    return {
      unsubscribe() {
        _this.remove(key);
      },
    };
  }

  remove(key): void {
    Module.modules = Module.modules.filter((d) => {
      return d.key !== key;
    });
  }

  skUserInit() {
    cr.each(Module.modules, (d) => {
      if (d.model.skUserInit) {
        d.model.skUserInit();
      }
    });
    Module.userStatus.init = true;
  }

  skUserEnd() {
    cr.each(Module.modules, (d) => {
      if (d.model.skUserEnd) {
        d.model.skUserEnd();
      }
    });
    Module.userStatus.end = true;
    Module.asyncStatus.userEnd.next("userEnd");
  }

  skUserChange(o) {
    cr.each(Module.modules, (d) => {
      if (d.model.skUserChange) {
        d.model.skUserChange(o);
      }
    });
  }

  skLinkEnd() {
    cr.each(Module.modules, (d) => {
      if (d.model.skLinkEnd) {
        d.model.skLinkEnd({ isJump: link.isJump });
      }
    });
  }

  skAuthEnd(o?: unknown) {
    cr.each(Module.modules, (d) => {
      if (d.model.skAuthEnd) {
        d.model.skAuthEnd(o);
      }
    });
  }

  skInit() {
    cr.each(Module.modules, (d) => {
      if (d.model.skInit) {
        d.model.skInit();
      }
    });
    Module.userStatus.skInit = true;
  }

  async update(instance: { [label: string]: any }) {
    if (instance.type === "link") {
      Module.instance = instance.data;
      Module.initLink();
    }
    if (instance.type === "auth") {
      const token = await auth.initAuth(
        instance.data.weChatId,
        instance.data.scope,
        instance.data.config
      );
      this.skAuthEnd(token);
    }
    if (instance.type === "common") {
      if (instance.data.weChatId) {
        await user.isAuth(instance.data.weChatId);
      }
      common.initParams(instance.data);
    }
    if (instance.type === "user") {
      user.updateUser();
      this.skUserChange(this.get().user);
    }
    cr.each(this.skModule, (d) => {
      if (d.skModuleType?.indexOf(instance.type) !== -1) {
        d.update(instance);
      }
    });
  }

  static async initLink() {
    await user.isAuth(Module.instance.weChatId);
    Module.asyncStatus.linkInit.next("linkEnd");
  }

  pushModule(o) {
    this.skModule.push(o);
  }

  get() {
    return {
      user: {
        globalUserId: user.globalUserId,
        session: user.session,
        memberId: user.memberId,
        name: user.name,
        unique: user.unique,
        uniqueType: user.uniqueType,
        token: user.token,
        tokenInfo: user.tokenInfo,
        openId: user.openId,
        status: user.status,
        formData: user.formData,
        wxInfo: user.wxInfo,
        wxQrCode: user.wxQrCode,
        subscribeOpenId: user.subscribeOpenId,
        updateCookieId: () => {
          return user.updateCookieId();
        },
      },
      cookie: {
        removeCookieId: removeCookieId,
        getOpenId: getOpenId,
        setOpenId: setOpenId,
        removeOpenId: removeOpenId,
        getSession: getSession,
        setSession: setSession,
        removeSession: removeSession,
        getVerify: getVerify,
        setVerify: setVerify,
        removeVerify: removeVerify,
        getVerifyInfo: getVerifyInfo,
        setVerifyInfo: setVerifyInfo,
        removeVerifyInfo: removeVerifyInfo,
        getToken: getToken,
        setToken: setToken,
        removeToken: removeToken,
        getTokenInfo: getTokenInfo,
        setTokenInfo: setTokenInfo,
        removeTokenInfo: removeTokenInfo,
      },
      common: {
        schemaId: common.schemaId,
        tenantId: common.tenantId,
        instanceId: common.instanceId,
        moduleId: common.moduleId,
        siteId: common.siteId,
        objId: common.objId,
        status: common.status,
        meetingInfo: link.meetingInfo,
        customFormInfo: link.customFormInfo,
        memberInfo: link.memberInfo,
        search: common.search,
        router: common.router,
        objMark: common.objMark,
        type: common.type,
        isOpenCallingCode: common.isOpenCallingCode,
      },
      link: link.jumpUrl,
    };
  }
}

export { Module };
